import { CustomTooltip } from '@/components/custom-tooltip';
import { usePropertyContext } from 'context/propertyContext';
import { formatDateWithGivenFormatter } from 'features/dates/date-helpers';
import { labels } from 'locales/en.label';
import { twoDecimalRateFormatter } from 'pages/MyView/tableCustomCellRender';

const tooltipLabels = labels.comp_rates.tooltip;

interface LiveMarketData {
	marketRate: number;
	changes: { day: number; value: number }[];
}

interface LiveMarketTooltipProps {
	data: LiveMarketData;
	stayDate: string;
	children: React.ReactElement<any, any> & React.ReactNode;
}

const format = (value: string) =>
	formatDateWithGivenFormatter(value, 'M/DD/YY');

export const LiveMarketTooltip = ({
	data,
	stayDate,
	children,
}: LiveMarketTooltipProps) => {
	const { currencySymbol } = usePropertyContext();

	return (
		<CustomTooltip
			placement='bottom'
			backgroundColor='tw-bg-white'
			arrowColor='tw-fill-primary'
			arrow
			borderColor='tw-border-primary'
			content={
				<div className='comp-rate-tooltip'>
					<div className='row'>
						<span className='label'>{tooltipLabels.stay_date}</span>
						<span>{format(stayDate)}</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.rate}</span>
						<span>
							{currencySymbol}
							{twoDecimalRateFormatter(data.marketRate ?? 0)}
						</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.rate_changes}</span>
					</div>
					{data.changes?.map(({ day, value }) => (
						<div className='row' key={day}>
							<span className='label sub'>{tooltipLabels.days_ago(day)}</span>
							<span>
								{currencySymbol}
								{twoDecimalRateFormatter(value)}
							</span>
						</div>
					))}
				</div>
			}
		>
			{children}
		</CustomTooltip>
	);
};
